var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('google-sign-in-button',{attrs:{"id":"google-signin-button","on-sign-in":_vm.onSignIn,"on-failure":_vm.onFailure}},[_c('span',[_vm._v("Log in with Google")])])}
var staticRenderFns = []

export { render, staticRenderFns }